// Real-estate transaction stages. Shared by the staff detail page and the
// public /tx/:shareToken status page.

export const STAGES = [
  { key: 'prospect', label: 'Prospect', color: '#94a3b8' },
  { key: 'showing', label: 'Showing', color: '#a3a3a3' },
  { key: 'offer_out', label: 'Offer Out', color: '#3b82f6' },
  { key: 'offer_accepted', label: 'Offer Accepted', color: '#6366f1' },
  { key: 'under_contract', label: 'Under Contract', color: '#8b5cf6' },
  { key: 'inspection', label: 'Inspection', color: '#f59e0b' },
  { key: 'appraisal', label: 'Appraisal', color: '#f97316' },
  { key: 'financing', label: 'Financing', color: '#facc15' },
  { key: 'clear_to_close', label: 'Clear to Close', color: '#8DC63F' },
  { key: 'closed', label: 'Closed', color: '#22c55e' },
  { key: 'cancelled', label: 'Cancelled', color: '#ef4444' },
  { key: 'fell_through', label: 'Fell Through', color: '#dc2626' },
];

// Terminal fail stages: not part of the forward progress track.
export const FAIL_STAGES = ['cancelled', 'fell_through'];
